export default __webpack_public_path__ + "static/media/ic-back-arrow.8328fed9.svg";